import React from "react";
import ActionList from "../SelectedDevice/ActionList" 
const StateList = (props) => {
  const {rx_action_list, t_delete_action_by_id, icons} = props

  const rx_state_list = [
    {
      id: 1,
      code: "HUM",
      value: "56923 3 53",
      description: "Internet enabled. IP: 192.168.0.103",
      date_created: "5/5/2025, 4:45:12 PM",
    },
    {
      id: 2,
      code: "HUM",
      value: "56923 3 53",
      description: "WiFi connected ssid: Keenetic-4010",
      date_created: "5/5/2025, 4:45:12 PM",
    },
    {
      id: 3,
      code: "TEMP",
      value: "56923 3 53",
      description: "Device Started",
      date_created: "5/5/2025, 4:45:12 PM",
    },
  ];
/* 
  const icons = {
    id: "🆔",       // ID button
    device: "📱",   // mobile phone
    code: "⌨️",     // keyboard
    value: "🔢",    // numbers
    description: "📝", // memo
    created: "🕒"   // clock
  }; */
  
  if (!rx_action_list || rx_action_list.length === 0) return null;

  const handleDelete =(action_id) => {
    console.log(action_id)
    t_delete_action_by_id(action_id)

  }

  return (
    <div className="container ">
    {/* Desktop Table (hidden on mobile) */}
    <div className="d-none d-md-block">
      <ActionList
        rx_action_list = {rx_action_list}
        t_delete_action_by_id = {t_delete_action_by_id}
      />
    </div>

      {/* Mobile Display (hidden on desktop) */}
      <div className="d-md-none" style={{ marginLeft: "-30px", marginRight: "-30px" }}>
        <div className="list-group">
          {rx_action_list.map((item, index) => (
            <div 
              key={item.id}
              className={`list-group-item ${index % 2 === 0 ? 'bg-light' : 'bg-white'} p-1 mb-2 rounded`}
            >
              {/* Display key-value pairs with pictograms */}
              <span style={{ fontSize: '0.9rem' }}>
                id: {item.id} | 
                code: {item.code} |
                value: {item.value} |
                result: {item.result || '-'}
                </span>
              {/*   <span className="text-decoration-underline" onClick={()=> {handleDelete(item.code)}}>Delete
              </span> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StateList;

/* 


      <h4 className="mb-3">Sensor Status</h4>
      
      
      <div className="d-none d-md-block">
        <table className="table table-striped table-bordered">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Code</th>
              <th>Value</th>
              <th>Description</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {rx_state_list.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.code}</td>
                <td>{item.value ?? "-"}</td>
                <td>{item.description ?? "-"}</td>
                <td>{new Date(item.date_created).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
*/